import React, { useState } from "react";
import style from "./index.module.scss";
import { Spin, DatePicker } from "antd";
import useRequest from "utils/useRequest";
import { getChannelOverviewAndInteractiveStatistics } from "service/liveRecord";
import General from "./components/General";
import CountOnline from "./components/CountOnline";
import Interaction from "./components/Interaction";
import ViewSt from "./components/ViewSt";
import titleIcon from "./img/titleIcon.png";
import { RangePickerValue } from "antd/lib/date-picker/interface";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
interface LiveStatisticsProps {
    courseSeq: string;
    channelId: string; //频道号
}

const defaultProps = {
    chatNum: 0, //聊天次数
    answerCardNum: 0, //答题卡次数
    avgPlaybackUV: 0, //回看平均人数
    avgDuration: 0, //直播平均时长
    answerCardRate: 0, //答题卡参与率
    signRate: 0, //签到参与率
    questionnaireNum: 0, //发布问卷次数
    avgPlaybackPV: 0, //回看平均次数
    signNum: 0, //签到次数
    questionnaireRate: 0, //发布问卷参与率
    avgTotalPlayDuration: 0, //观看平均时长
    avgLiveUV: 0, //在线平均人数
    playbackNum: 0, //累计回访次数
    channelId: 0, //频道号
    sessionsNum: 0 //累计直播次数
};
const { RangePicker } = DatePicker;

export default function LiveStatistics({ channelId }: LiveStatisticsProps) {
    const nowTime = moment().endOf("day").format("YYYY-MM-DD");
    // const sevenTime =
    //     moment().subtract(7, "days").format("YYYY-MM-DD") + " 0:0:0";
    const sevenTime = moment().subtract(7, "days").format("YYYY-MM-DD");
    const [time, setTime] = useState<[string, string]>([sevenTime, nowTime]);
    const [data, { loading }] = useRequest(
        () => getChannelOverviewAndInteractiveStatistics(channelId),
        {},
        [channelId, time]
    );
    function onChange(date: RangePickerValue, dateString: [string, string]) {
        setTime(dateString);
    }
    return (
        <div className={style.root}>
            <Spin spinning={loading}>
                <div className={style.header}>
                    <img className={style.titleIcon} src={titleIcon} alt="" />
                    概况统计&nbsp;&nbsp;&nbsp;
                    <span className={style.tip}>
                        温馨提示：仅⽀持统计截⽌到当⽇之前的直播情况，当⽇的直播情况请于次⽇查看
                    </span>
                </div>
                <General {...defaultProps} {...data} />
                <div className={style.header}>
                    <img className={style.titleIcon} src={titleIcon} alt="" />
                    在线人数
                    <div className={style.headerright}>
                        时间筛选 &nbsp;&nbsp;
                        <RangePicker
                            defaultValue={[
                                moment(sevenTime, "YYYY-MM-DD"),
                                moment(nowTime, "YYYY-MM-DD")
                            ]}
                            onChange={onChange}
                        />
                    </div>
                </div>
                <CountOnline time={time} channelId={channelId} />
                <div className={style.header}>
                    <img className={style.titleIcon} src={titleIcon} alt="" />
                    互动统计
                </div>
                <Interaction
                    {...defaultProps}
                    {...data}
                    channelId={channelId}
                />

                <ViewSt channelId={channelId} />
            </Spin>
        </div>
    );
}
